<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>
            <span>{{ editState?'ویرایش سگمنت سفارشی':'ایجاد سگمنت' }}</span>
          </b-card-title>
          <b-row align-h="center">
            <b-col
              class="mt-2"
              md="10"
            >
              <b-row class="p-1 m-1 border rounded">
                <b-col cols="6">
                  <b-form-group
                    label="عنوان"
                    label-for="Title"
                  >
                    <b-form-input
                      v-model="form.Title"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="توضیحات"
                    label-for="Description"
                  >
                    <div class="form-label-group">
                      <b-form-input
                        id="Description"
                        v-model="form.Description"
                        name="Description"
                        autocomplete="off"
                      />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-radio-group
                      v-model="dateType"
                      :options="dateTypes"
                      value-field="key"
                      class="mt-1"
                      @change="primitiveSegment.id=null"
                  />
                  <b-row v-if="dateType === 'range'" class="mt-2">
                    <b-col md="4">
                      <b-form-group
                          label="تاریخ شروع"
                          label-for="FromDate"
                      >
                        <date-picker
                            v-model="FromDate"
                            placeholder=""
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group
                          label="تاریخ پایان"
                          label-for="ToDate"
                      >
                        <date-picker
                            v-model="ToDate"
                            placeholder=""
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-else class="mt-2">
                    <b-col cols="6">
                      <b-form-group
                          label="محدودیت تعداد روز اخیر"
                          label-for="FromDays"
                      >
                        <b-form-input
                            v-model="FromDays"
                            autocomplete="off"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-form-group class="mt-1 mb-2">
                    <b-form-checkbox v-model="form.AutoInsertNewUser" class="custom-control-info">
                      کاربران جدید به این سگمنت اضافه شوند
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="d-flex p-1 m-1 border rounded">
                <div>
                  <b-form-radio-group
                    v-model="primitiveSegment.type"
                    :options="enums('segmentType')"
                    class="mt-1"
                    @change="primitiveSegment.id=null"
                  />
                </div>
                <div class="flex-grow-1 ml-1">
                  <component
                    :is="enums('segmentType','value',primitiveSegment.type,'component')"
                    v-model="primitiveSegment.id"
                    :multiple="false"
                    class="full-width"
                  />
                </div>
              </div>
              <template
                v-for="(question,index) in questions"
              >
                <div class="text-center border rounded p-1 m-1">
                  <template
                    v-for="operation in question.operations"
                  >
                    <div class="d-inline-block">
                      <b-img
                        :src="require(`@/assets/images/join/${operation.src}.png`)"
                        rounded
                        alt="operationImage image"
                        class="d-inline-block mr-1 mb-1 p-1 cursor-pointer"
                        :class="{'bg-success' : operation.select}"
                        height="80"
                        @click="question.operations.forEach(ope=> ope.select= ope.key=== operation.key)"
                      />
                    </div>
                  </template>
                </div>
                <div class="d-flex border rounded p-1 m-1">
                  <div>
                    <b-form-radio-group
                      v-model="question.segmentType"
                      :options="enums('segmentType')"
                      class="mt-1"
                      @change="question.segment=null"
                    />
                  </div>
                  <div class="flex-grow-1 ml-1">
                    <component
                      :is="enums('segmentType','value',question.segmentType,'component')"
                      v-model="question.segment"
                      :multiple="false"
                      class="full-width"
                    />
                  </div>
                  <div class="ml-1">
                    <b-button variant="outline-secondary">
                      <feather-icon
                        icon="TrashIcon"
                        @click="remove(index)"
                      />
                    </b-button>
                  </div>
                </div>
              </template>
              <b-button
                variant="primary"
                class="ml-1"
                @click="addQuestion"
              >
                اضافه
              </b-button>
              <b-col cols="12">
                <hr>
              </b-col>
              <b-col class="mt-1 mb-2 text-center">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="save"
                >
                  ذخیره
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  @click="back"
                >
                  بازگشت
                </b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import selectSegmentBasic from '@/tools/selectSegmentBasic.vue'
import selectSegmentCustom from '@/tools/selectSegmentCustom.vue'
import selectDeclaration from '@/tools/selectDeclaration.vue'

export default {
  name: 'CustomSegment',
  components: { selectSegmentBasic, selectSegmentCustom, selectDeclaration },
  data() {
    return {
      loading: false,
      editState: false,
      form: {
        Title: null,
        Description: null,
        Id: null,
        AutoInsertNewUser: false
      },
      primitiveSegment: {
        id: 0,
        type: 0,
      },
      questions: [],
      dateType: 'range',
      dateTypes: [
        { key: 'range', text: 'بازه تاریخی' },
        { key: 'day', text: 'محدودیت تعداد روز اخیر' }
      ],
      FromDate: '',
      ToDate: '',
      FromDays: '',
    }
  },
  operations: [
    {
      src: 'innerJoin',
      key: 0,
      select: true,
    },
    {
      src: 'leftJoinExclude',
      key: 4,
      select: false,
    },
    {
      src: 'outerJoinExclude',
      key: 2,
      select: false,
    },
    {
      src: 'outerJoin',
      key: 1,
      select: false,
    },
    {
      src: 'rightJoinExclude',
      key: 3,
      select: false,
    },
  ],
  created() {
    if (this.$route.params.id) {
      this.form.Id = this.$route.params.id
      this.editState = true
      this.getSingle(this.$route.params.id)
    }
  },
  methods: {
    getSingle(id) {
      this.loading = true
      this.$http.post(this.$api.segmentCustom.get, { Id: id }).then(response => {
        let questions = response.data.SegmentDetails.reverse().map((content, index, array) => ({
          segmentType: content.Entity,
          segment: content.Id,
          operations: array.length - 1 !== index ? array[index + 1].Join : null,
        })).reverse()
        const startSegment = questions.shift()

        questions = questions.map(q => {
          const segmentOperations = this.$options.operations.map(operation => ({
            key: operation.key,
            src: operation.src,
            select: operation.key === q.operations,
          }))
          return {
            segmentType: q.segmentType,
            segment: q.segment,
            operations: segmentOperations,
          }
        })
        this.primitiveSegment.id = startSegment.segment
        this.primitiveSegment.type = startSegment.segmentType
        this.form.Title = response.data.Title
        this.form.Description = response.data.Description
        this.FromDate = response.data.FromDate
        this.form.AutoInsertNewUser = response.data.AutoInsertNewUser
        this.FromDays = response.data.FromDays
        this.questions = null
        this.questions = questions
        this.loading = false
        if (this.FromDate || this.ToDate) this.dateType = 'range'
        else if (this.FromDays) this.dateType = 'day'
      }).finally(() => { this.loading = false })
    },
    addQuestion() {
      this.questions.push({
        operations: [
          {
            src: 'innerJoin',
            key: 0,
            select: true,
          },
          {
            src: 'leftJoinExclude',
            key: 4,
            select: false,
          },
          {
            src: 'outerJoinExclude',
            key: 2,
            select: false,
          },
          {
            src: 'outerJoin',
            key: 1,
            select: false,
          },
          {
            src: 'rightJoinExclude',
            key: 3,
            select: false,
          },
        ],
        segment: 1,
        segmentType: 0,
      })
    },
    save() {
      this.loading = true
      let url = this.$api.segmentCustom.add
      if (this.$route.params.id) {
        url = this.$api.segmentCustom.update
      }
      let data = {
        ...this.form,
        SegmentDetails: this.makeSendObject()
      }
      if (this.dateType === 'range') {
        data.FromDate = this.FromDate
        data.ToDate = this.ToDate
      } else data.FromDays = this.FromDays
      this.$http.post(url, data).then(() => {
        this.loading = false
        this.back()
      }).finally(() => { this.loading = false })
    },
    makeSendObject() {
      let SegmentDetails = []

      SegmentDetails = this.questions.map(elem => ({
        Entity: elem.segmentType,
        Id: elem.segment,
        Join: elem.operations.filter(op => op.select === true)[0].key,
      }))
      // add primitive segment on first element  of question  array
      SegmentDetails.unshift({
        Entity: this.primitiveSegment.type,
        Id: this.primitiveSegment.id,
        Join: null,
      })
      SegmentDetails = SegmentDetails.map((content, index, array) => ({
        Entity: content.Entity,
        Id: content.Id,
        Join: array.length - 1 !== index ? array[index + 1].Join : null,
        Order: index,
      }))
      return SegmentDetails
    },
    remove(index) {
      this.questions.splice(index, 1)
    },
  },
}
</script>

<style scoped>

</style>
